import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { createPortal } from 'react-dom'

import { selectStation } from 'redux/selector/app'
import { AppContext } from 'app-layered-layout/AppProvider'
import { useAnimationState } from 'app-layered-layout/useAnimationState'
import { NAV_TYPE_GAME } from 'constant/common'
import { useIpBanCheck } from 'hooks/useIpBanCheck'
import { useNavigationLocalData } from './hooks/useNavigationLocalData'

import { Wrapper, TagA, Nav, NavIcon, NavAesIcon, NavText, NavigationSpacer } from './Styled'
import { INDEX } from 'constant/routers'

let navPortalRoot: HTMLDivElement | null = null

function getNavPortalRoot(): HTMLDivElement {
  if (!navPortalRoot) {
    navPortalRoot = document.getElementById('nav-portal-root') as HTMLDivElement | null
    if (!navPortalRoot) {
      navPortalRoot = document.createElement('div')
      navPortalRoot.id = 'nav-portal-root'
      document.body.appendChild(navPortalRoot)
    }
  }
  return navPortalRoot
}

/** 元件 - Bottom Navigation */
export default function Navigation() {
  const location = useLocation()
  const { navContent } = useNavigationLocalData()
  const station = useSelector(selectStation)
  const { active } = useContext(AppContext)
  const { visible } = useAnimationState()
  const { validateIpBan } = useIpBanCheck()

  const show = active && visible

  const isInvalidNavId =
    location?.pathname === INDEX &&
    navContent?.findIndex((i: any) => /nav_id=\d+/.exec(location.search)?.[0] === /nav_id=\d+/.exec(i.search)?.[0]) ===
      -1

  const navContent_ = (
    <Wrapper>
      {navContent?.map(
        ({ name, imageName, navLink, dynamicIconActive, dynamicIconInactive, search, id, type }: any, i: number) => {
          const isNavActive =
            navLink === INDEX
              ? (isInvalidNavId && /nav_id=\d+/.exec(search)?.[0] == null) ||
                (location?.pathname === navLink &&
                  /nav_id=\d+/.exec(location.search)?.[0] === /nav_id=\d+/.exec(search)?.[0])
              : location?.pathname === navLink

          return (
            <TagA
              key={i}
              to={navLink + search}
              replace
              beforeNavigate={type === NAV_TYPE_GAME ? validateIpBan : undefined}
            >
              <Nav>
                {!dynamicIconActive ? (
                  <NavIcon active={isNavActive} imageName={imageName} />
                ) : (
                  <NavAesIcon
                    source={process.env.REACT_APP_NAV_IMAGE_SOURCE}
                    decryptKey={station.cover_key}
                    src={isNavActive ? dynamicIconActive : dynamicIconInactive}
                  />
                )}
                <NavText active={isNavActive}>{name}</NavText>
              </Nav>
            </TagA>
          )
        }
      )}
    </Wrapper>
  )

  return (
    <>
      <NavigationSpacer />
      {createPortal(
        <div
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 10,
            opacity: show ? 1 : 0,
            transition: 'opacity 0.25s ease',
            pointerEvents: show ? 'auto' : 'none',
          }}
        >
          {navContent_}
        </div>,
        getNavPortalRoot()
      )}
    </>
  )
}
